<div class="container">

  <div class="field is-grouped">

    <div class="control has-icons-left">
      <input class="input"
             type="text"
             placeholder="Поиск по имени"
             (input)="onSearch($event)" />
      <span class="icon is-left">
        <i class="fas fa-search"></i>
      </span>
    </div>

    <div class="field is-grouped ml-auto">
      <div class="control">
        <input class="input"
               type="text"
               placeholder="Имя нового таймлайна"
               [(ngModel)]="newTimelineName" />
      </div>
      <div class="control">
        <button class="button is-success" (click)="addTimeline()">Добавить таймлайн</button>
      </div>
    </div>

  </div>

  <div class="columns">
    <div class="column">
      <table class="table" style="width: 100%">
        <thead>
          <tr>
            <th>Имя</th>
            <th>Кол-во сессий</th>
            <th>Изменен</th>
            <th>Создан</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let timeline of timelines$ | async">
            <td>
              <a (click)="viewTimeline(timeline.id)">{{ timeline.name }}</a>
            </td>
            <td>
              {{timeline.numberOfSessions}}
            </td>
            <td>
              {{ timeline.updatedAt | date: 'dd/MM/yyyy' }}
            </td>
            <td>
              {{ timeline.createdAt | date: 'dd/MM/yyyy' }}
            </td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="isLoading" class="has-text-centered">
        <button class="button is-loading">Загрузка...</button>
      </div>
    </div>

    <div class="column is-one-third" *ngIf="selectedTimeline">
      <h3 class="title is-4">
        {{selectedTimeline.name}} ({{selectedTimeline.sessions?.length}})
      </h3>

      <table class="table is-fullwidth">
        <tr *ngFor="let session of selectedTimeline.sessions">
          <td>
            <a [routerLink]="'/sessions/edit/' + session.id">
              {{session.name}}
            </a>
          </td>
          <td>
            <div class="tags">
              <span *ngFor="let tag of session.tags" class="tag is-link">{{tag}}</span>
            </div>
          </td>
        </tr>
      </table>    

    </div>
  </div>

</div>
